import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const MODULES = [{
  num: '01',
  title: 'Protocolo H.E.R. — Plan de 21 días',
  subtitle: 'Sabés exactamente qué hacer cada día para acompañar esta etapa. Sin improvisar.'
}, {
  num: '02',
  title: 'Tracker Premium H.E.R. — 21 días',
  subtitle: 'Visualizá tu progreso día a día y mantenete enfocada durante las 3 semanas.'
}, {
  num: '03',
  title: 'Noche en Calma — 7 noches de ritual',
  subtitle: 'Un protocolo simple para reducir el estrés nocturno, mejorar el descanso y cortar el ciclo de antojos.'
}, {
  num: '04',
  title: 'H.E.R. Movement — 21 rutinas en casa',
  subtitle: 'Movete entre 15 y 25 minutos por día para sentirte mejor, sin gimnasio ni equipos costosos.'
}, {
  num: '05',
  title: 'Guía de compras Argentina + Meal Prep',
  subtitle: 'Resolvé qué comprar y qué cocinar para las próximas 3 semanas en pocos minutos.'
}, {
  num: '06',
  title: 'Recetario H.E.R. — 63 recetas',
  subtitle: 'Comidas simples y reales, adaptadas a ingredientes argentinos y a esta etapa de tu vida.'
}];
export function ForWhoSection() {
  // Acordeón premium de apertura única: abrir un módulo cierra el anterior.
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => setOpenIndex(prev => prev === i ? null : i);
  return <section className="bg-gradient-hero py-20 md:py-28 px-4 md:px-8" style={{
    paddingTop: "19px"
  }} data-id="element-118" data-mp="2b011aloiii43">
      <div className="max-w-3xl mx-auto" data-id="element-119" data-mp="2g06va8i98gpc">
        <div className="text-center mb-10 md:mb-14" data-id="element-120" data-mp="2fz43zzh0sc8w">
          <p className="uppercase tracking-[0.28em] text-[#C8A870] font-semibold mb-4 text-[13px]" data-id="element-121" data-mp="21batgt6sjzx6">
            El sistema completo
          </p>

          <h2 className="font-display text-4xl md:text-5xl font-semibold text-[#F0E8D8] leading-[1.1]" data-id="element-122" data-mp="26817laz1clfy">
            Qué recibís{' '}
            <span className="italic text-gradient-gold" data-id="element-123" data-mp="2yq54irxsgfuk">al entrar</span>
          </h2>

          
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative mt-12 md:mt-16 px-2 md:px-10" data-id="element-124" data-mp="38mng6w5crcjr">
          <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none" data-id="element-125" data-mp="2zjw3yu4nkcr2">
            <div className="w-[80%] h-[80%] rounded-full bg-gold/10 blur-[90px]" data-id="element-126" data-mp="2um2xs13cniqs" />
          </div>

          <div className="rounded-[4px] overflow-hidden border-[0.5px] border-gold/25 shadow-[0_0_60px_rgba(200,168,112,0.08),0_30px_60px_rgba(0,0,0,0.55)] bg-white/[0.02]" data-id="element-127" data-mp="2pokmw55rutg5">
            <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/blunde.png?v=1779840976" alt="Sistema completo H.E.R." loading="eager" className="w-full h-auto block" data-id="element-128" data-mp="2fy9hee6fwc75" />
          </div>

          
        </motion.div>

        {/* Acordeón editorial de los 6 módulos */}
        <motion.ul initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mt-10 md:mt-12 max-w-xl mx-auto" data-id="element-129" data-mp="21xf7fr3qu36d">
          {MODULES.map((item, i) => {
          const isOpen = openIndex === i;
          return <li key={item.num} className="border-b-[0.5px] border-gold/10 last:border-0" data-id="element-130" data-mp="relow1in80ts" data-mpi={i}>
               <button type="button" onClick={() => toggle(i)} aria-expanded={isOpen} className="w-full flex items-center gap-3 text-left py-4 group focus:outline-none" data-id="element-131" data-mp="vemhcq2kucju">
  <span className="text-[13px] text-foreground/35 font-body font-medium flex-shrink-0" data-id="element-132" data-mp="3ngew2zdw2re">
    {item.num}
  </span>

  <span className="
      flex-1
      font-display
      text-[18px]
      md:text-[17px]
      leading-[1.35]
      font-medium
      text-[#C8A870]
      transition-colors
      duration-300
      group-hover:text-[#E8D5B0]
    " data-id="element-133" data-mp="7p1kr4di3gs3">
    {item.title}
  </span>

  <motion.span animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.28,
                ease: "easeOut"
              }} className="
      flex-shrink-0
      text-[#C8A870]/70
      group-hover:text-[#E8D5B0]
      transition-colors
      duration-300
    " data-id="element-134" data-mp="3g5ei0wlqxall">
    <ChevronDownIcon className="w-5 h-5" data-id="element-135" data-mp="36quniy6df1ov" />
  </motion.span>
</button>

<AnimatePresence initial={false} data-id="element-136" data-mp="36s5roz3qabgi">
  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                height: {
                  duration: 0.4,
                  ease: [0.22, 1, 0.36, 1]
                },
                opacity: {
                  duration: 0.25
                }
              }} className="overflow-hidden" data-id="element-137" data-mp="31zkynzsnc2e1">
      <div className="pb-7 pl-[29px] pr-2" data-id="element-138" data-mp="3pnmbhkwuy4z9">

        {/* DESCRIPCIÓN */}
        <p className="font-body text-[16px] md:text-[15px] leading-[1.75] text-foreground/80 max-w-[720px]" data-id="element-139" data-mp="3kr5fy5nbwoc5">
          {item.description}
        </p>

        {/* MAPA DEL MÉTODO — SOLO PARA EL PROTOCOLO */}
        {item.num === "01" && <motion.div initial={{
                    opacity: 0,
                    y: 12
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} transition={{
                    duration: 0.45,
                    delay: 0.08,
                    ease: "easeOut"
                  }} className="mt-7" data-id="element-140" data-mp="5uk4tvpxzo0g">
            <div className="mb-4" data-id="element-141" data-mp="3s80v1s8zbeup">
              <p className="font-body text-[11px] tracking-[0.24em] uppercase text-[#C8A870]/70" data-id="element-142" data-mp="13ahx2vs2ys9">
                El método H.E.R.
              </p>

              <h3 className="mt-1 font-display text-[23px] md:text-[25px] leading-[1.25] text-[#E8D5B0]" data-id="element-143" data-mp="3j85fzccayzpe">
                Tres fases. 21 días.
              </h3>
            </div>

            <div className="overflow-hidden rounded-[2px] border border-[#C8A870]/20 bg-[#0d0c0a]" data-id="element-144" data-mp="39ckh3n2j6fjv">
              <img src="/images/mapa-del-metodo.png" alt="Mapa del método H.E.R.: tres fases de 21 días" className="
                  block
                  w-full
                  h-auto
                  object-contain
                " loading="lazy" data-id="element-145" data-mp="3eb5bh5v3q50e" />
            </div>

            <p className="mt-4 font-body text-[13px] leading-[1.7] text-foreground/55" data-id="element-146" data-mp="1630cqnxwkcar">
              Un recorrido de tres fases para acompañar tu cuerpo paso a paso.
            </p>
          </motion.div>}

      </div>
    </motion.div>}
</AnimatePresence>

                <AnimatePresence initial={false} data-id="element-147" data-mp="w6xf9vdzx1u5">
                  {isOpen && <motion.div key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-148" data-mp="1tr067vmlmgt1">
                      <p className="font-body pl-7 pr-2 pb-5 -mt-1 text-[#F0E8D8] text-[16px] leading-[1.6]" data-id="element-149" data-mp="2cjkut0v9lzr1">
                        {item.subtitle}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </motion.ul>
      </div>
    </section>;
}